
import { CorpusStats } from "@/constants/corpus.constants";
import { CorpusStatItem } from "./stat-item";
import { formatTitleFromKey } from "@/services/corpus-util.service";

/**
 * Props for the StatsSection component
 */
interface Props {
  /** Corpus statistics data */
  stats: CorpusStats | null | undefined;
}

/**
 * StatsSection component displays a grid of corpus stat items. Maps over stats
 * object entries and renders CorpusStatItem for each corpus type. Returns null
 * if stats are not available.
 * 
 * @component
 * @param {Props} props - Component props
 * @param {CorpusStats | null | undefined} props.stats - Corpus statistics
 * @returns {JSX.Element | null} Grid of stat items or null if no stats
 * 
 * @example
 * ```tsx
 * <StatsSection stats={corpusStats} />
 * ```
 */
export const StatsSection = ({ stats }: Props) => {
  if (!stats) return null;

  return (
    <div className="flex flex-col gap-4 w-full">
      {/* Render dynamic corpus stat items */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
        {Object.entries(stats).map(([key, val]) => (
          <CorpusStatItem
            key={key}
            title={formatTitleFromKey(key)}
            total={val.total}
            success={val.success}
            failed={val.failed}
            inProgress={val.inprogress}
          />
        ))}
      </div>
    </div>
  );
};